module.exports = __webpack_public_path__ + "img/Faderen_Bilde-av-gravstein.ae4d8441.jpg";